// removed by extract-text-webpack-plugin
module.exports = {"search":"SearchControl_search--2qAAV","inputContainer":"SearchControl_inputContainer--3E9VQ","label":"SearchControl_label--3jfUm","buttonSearch":"SearchControl_buttonSearch--1Xwlh","input":"SearchControl_input--eK6EC","searchIcon":"SearchControl_searchIcon--kGmtq","clear":"SearchControl_clear--3gox_","clear__visible":"SearchControl_clear__visible--1rrHg","clearVisible":"SearchControl_clear__visible--1rrHg"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/SearchControl/SearchControl.scss
// module id = 2269
// module chunks = 11